import React from 'react'
import { useNavigate } from 'react-router-dom'
//import styles
import style from './a.module.scss'
//import components
import Navbar from '../../components/Navbar/Navbar'
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import HeroSection from '../Projects/components/HeroSection'
import Card from './components/Card'
//import assets
import profileImage from '../../assets/test-profile-image.svg'
import searchIcon from "../../assets/icons/search.svg"
import settingIcon from "../../assets/icons/setting.svg"

const testCardData = [
	{
		projectName:"Web Development Project",
		projectBy:"Aryan Jangid",
		projectInfo:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/aryan",
		imgSrc: profileImage
	},
	{
		projectName:"Web Development Project",
		projectBy:"Aryan Jangid",
		projectInfo:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/aryan",
		imgSrc: profileImage
	},
	{
		projectName:"Web Development Project",
		projectBy:"Aryan Jangid",
		projectInfo:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/aryan",
		imgSrc: profileImage
	},
	{
		projectName:"Web Development Project",
		projectBy:"Aryan Jangid",
		projectInfo:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/aryan",
		imgSrc: profileImage
	},
	{
		projectName:"Web Development Project",
		projectBy:"Aryan Jangid",
		projectInfo:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/aryan",
		imgSrc: profileImage
	},
	

]

const Projects = () => {

	const SearchPanel = () => {
		return(
			<div className={style.searchPanel}>
				<div className={style.inputDiv}>
					<img src={searchIcon} alt="icon"></img>
					<input placeholder="Search project"></input>
				</div>
				<div className={style.inputDiv}>
					<img src={settingIcon} alt="icon"></img>
					<select>
						<option value="Skills">Skills</option>
						<option value="Name">Project Name</option>
						<option value="Type">Project Type</option>
						<option value="Mentor Name">Mentor Name</option>
						<option value="Mentee Name">Mentees Name</option>
					</select>
				</div>
				<div>
					<PrimaryButton  title="Search"/>
				</div>
			</div>
		)
	}

  const SearchResults = () => {
		return (
			<div className={style.searchResults}>
				{testCardData.map((data) =>{
					return(
						<Card data={data}/>
					)
				})}
			</div>
		)
	}

  return (
    <div>
        <Navbar />
		<div className="AppNavbarGap"></div>
        <HeroSection />
		<SearchPanel />
        <SearchResults />
    </div>
  )
}

export default Projects